import Axios from 'axios';
import config from 'config/config';
import {InvitationDataResponse, AcceptInvitationPayload, RequestResetPasswordPayload, ImpersonationRequest} from 'model/api';

export const signInUserRequest = async (username: string, password: string) => {
  const response = await Axios.post('/oauth2/token', {
    username,
    password,
    grant_type: 'password',
    client_id: config.clientId,
    client_secret: config.clientId
  }, { baseURL: config.baseApiV1Url });
  return response.data;
}

export const signOutUserRequest = async () => {
  const response = await Axios.post('/session/logout');
  return response.data;
}

export const getRegistrationTokenData = async (token: string): Promise<InvitationDataResponse> => {
  const response = await Axios.get(`/accounts/invite/token?token=${token}`);
  return response.data;
}

export const acceptInvitation = async (payload: AcceptInvitationPayload, token: string): Promise<any> => {
  const response = await Axios.post('/accounts/invite/accept', payload, { headers: { 'Authorization': `Bearer ${token}` } });
  return response.data;
}

export const requestResetPassword = async (payload: RequestResetPasswordPayload): Promise<any> => {
  const response = await Axios.post(`/users/password/request-reset`, payload);
  return response.data;
}

export const getResetPasswordToken = async (userId: string, token: string): Promise<any> => {
  const response = await Axios.get(`/users/requestreset/${userId}/${token}`, { baseURL: config.baseApiV1Url });
  return response.data;
}

export const resetPassword = async (password: string, token: string): Promise<any> => {
  const response = await Axios.put(`/users/me`, { password }, {
    baseURL: config.baseApiV1Url,
    headers: { authorization: token }
  });
  return response.data;
}

export const impersonateRequest = async (payload: ImpersonationRequest): Promise<any> => {
  const response = await Axios.post(`/users/impersonate`, payload);
  return response.data;
}